import {
  aboutFunc
} from "./pages/_about";

$(window).on('load', function () {
  aboutFunc();
});